// extracted by mini-css-extract-plugin
module.exports = {"accountTabsWrapper":"AccountsLayout_accountTabsWrapper__Vr9tz"};